import axios from "axios";
import Config from "src/config";

const v2_actionDeletarAutomacao = (id) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/automacoes/automacao/${id}/deletar`
    });
};

export default v2_actionDeletarAutomacao;
